// store/feature/patient/patientFormSlice.ts
import { SectionData } from "@/interface/patient.interface";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface PatientFormState {
  data: SectionData[];
}

const initialState: PatientFormState = {
  data: [],
};

export const patientFormSlice = createSlice({
  name: "patientForm",
  initialState,
  reducers: {
    setPatientData: (state, action: PayloadAction<SectionData[]>) => {
      state.data = action.payload;
    },
    setFieldValue: (state, action: PayloadAction<any>) => {
      // Update specific field values in the state
      const updatedData = state.data.map(section => ({
        ...section,
        fields: section.fields.map(field => ({
          ...field,
          value: action.payload[field.field] !== undefined 
            ? action.payload[field.field] 
            : field.value
        }))
      }));
      state.data = updatedData;
    },
  },
});

export const { setPatientData, setFieldValue } = patientFormSlice.actions;
export default patientFormSlice.reducer;